var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-alert", {
    attrs: {
      message: "*" + _vm.$t("默认节点权限为审核流上所有管理员可见，手动配置白名单后，对应节点仅白名单人员可见"),
      banner: ""
    }
  }), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "white",
      fn: function (text, record) {
        return [_c("a-select", {
          staticStyle: {
            width: "100%"
          },
          attrs: {
            mode: "multiple",
            placeholder: _vm.$t("请选择") + _vm.$t("需要配置的白名单")
          },
          model: {
            value: record.whitelist,
            callback: function ($$v) {
              _vm.$set(record, "whitelist", $$v);
            },
            expression: "record.whitelist"
          }
        }, _vm._l(_vm.whiteList, function (item, index) {
          return _c("a-select-option", {
            key: index,
            attrs: {
              value: String(item.id)
            }
          }, [_vm._v(" " + _vm._s(item.nickName) + " ")]);
        }), 1)];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("div", {
    staticClass: "marginT20"
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("Back");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };